import { ThumbsDown, ThumbsUp, X } from "lucide-react";

type FeedbackBarProps = {
  state: "helpful" | "not-helpful" | null;
  onHelpful: () => void;
  onNotHelpful: () => void;
  onClose: () => void;
};

export function FeedbackBar({ state, onHelpful, onNotHelpful, onClose }: FeedbackBarProps) {
  return (
    <div className="pk-feedback" data-testid="feedback-bar">
      <span>{state ? "Feedback captured" : "Was this estimate useful?"}</span>
      <button type="button" aria-label="Helpful" onClick={onHelpful}>
        <ThumbsUp size={16} />
      </button>
      <button type="button" aria-label="Not helpful" onClick={onNotHelpful}>
        <ThumbsDown size={16} />
      </button>
      <button type="button" aria-label="Close feedback" onClick={onClose}>
        <X size={15} />
      </button>
    </div>
  );
}
